module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-prologue element-with-heading",
    attrs: {
      "id": "prologue"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-mixed"
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle case-upper"
  }, [_vm._v("THE NORTH-LANE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "prologue-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("He hears the click.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A cold barrel rests against the head of Jackson Crowe. Its steel scrapes along his skin and pulls at his hair. Tears begin to roll from his dark eyes and tumble down his cheeks. As each salty drop falls from his chin, he lets out a quiet whimper, catching his breath in between like a panting dog on a hot day. Any moment now, a thunderous boom will rattle his skull with a confetti mixture of brain matter spraying the carpet. His assailant’s subtle laughter and cheeky grin ties knots in his stomach. Jackson is not afraid of death, and he is not shedding tears for his coming end, because a life without "), _c('i', [_vm._v("her")]), _vm._v(" was not a life at all. No, Jackson cries only for a love that would never be had again; not in "), _c('i', [_vm._v("this")]), _vm._v(" life. Each droplet that forms falls into the pool of blood beneath him that trailed as a river from the body beside him. Her once bright eyes had fallen gray and her hair lay stained in the pool of her own crimson. He loved her, maybe more than he ever had the chance to show. Another tear falls from his chin as he thought of the wedding that would now never be.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-125"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/d0a4e7a7c3efb7143d34a877d47e4c27-cowboy-revolver-gun-silhouette-by-vexels.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("The gun is so close to his head that Jackson can almost hear his finger sliding along the length of the trigger.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-125"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/d0a4e7a7c3efb7143d34a877d47e4c27-cowboy-revolver-gun-silhouette-by-vexels.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("“Ha... haha… Hmph. Ya cry like a lil’ baby, Jacks,” says the slender figure in the tan suit. His bloodshot red eyes fix on Jackson with a shattering grin, hair slicked back with grease and bushy eyebrows furrowed. “Ya lady friend didn’t weep "), _c('i', [_vm._v("this ")]), _vm._v("much.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“W-why…” Jackson retorts as his voice shook like a cocktail blended with equal parts fear and rage. “I n-never tangled with the Demons. I kept to myself... I–”")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('i', [_vm._v("The man in the tan suit pushes the gun into Jackson’s temple, and he winces as the metal shoves his head. But, his eyes, watery and stern, never leave the gunman.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("“CALL ME A FUCKIN’ DEMON AGAIN!” roars the figure. “Ya thinkin’ I "), _c('i', [_vm._v("wanted ")]), _vm._v("to stay on this shit hole? I "), _c('i', [_vm._v("died")]), _vm._v(" Jacks, died like a dog. But no, no North-Lane for me. So, I found the weakest wee lil’ bastard I could then I went out lookin’ for ya.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I don't understand! I didn’t "), _c('i', [_vm._v("do ")]), _vm._v("anything! P-please I didn’t even… I didn’t even live my life... I work at a bank, I don’t drink, I barely even leave the house. I would NEVER cross anyone!” Jackson pleads. “Y-you… you took her from … me. All that mattered.” It was as if her face, the very image of her smile and those wispy eyes, is so burned into him that it is all he can see through the clouds of tears. “Y-you took her… She did nothing wrong… "), _c('i', [_vm._v("I")]), _vm._v(" did no–”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Probably don’t know it’s me in this body, Jacks,” the grinning man interjects. “But, I know ya. I’ll give ya a brief history. Man walks in for a loan. Man lost his job that morning, wife and kid need some money. Man doesn’t get a loan because the man doesn’t currently have income. Little later your bank takes my house, and my wife takes my kid. But me, Jacks? Well I take a rope. I hang it from the chimney on my roof. I slide my neck in the hole, and I jump from the fuckin’ shingles.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"N-no...\" Jackson murmurs to himself with trembling lips. He exhales a large breath from rattled lungs, “You…” He whispers. “I didn’t know… that was "), _c('i', [_vm._v("months")]), _vm._v(" ago…”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Months, Jacks,” he repeats. “Months to find ya, months to plan, months to "), _c('i', [_vm._v("dwell")]), _vm._v(". Ya see,” the man places a thin finger to his temple and taps lightly as his eyes light up like fireworks over the flash of his teeth, “they don’t take ya if ya have a purpose. Oh,” he says whimsically as he stares down at the blubbering boy before him. “I "), _c('i', [_vm._v("had")]), _vm._v(" purpose alright, Jacks.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“W-what?” Jackson asks, “Who? Who doesn’t take you? I don’t understand…”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“If you’re as unlucky as me, then maybe you’ll find out.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jackson whimpers a little louder and shakes his head. “I was just doing my job… I was just doing my–”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Me too. Enjoy the ride on the North-Lane, Jacks.” He says softly, “Maybe ya lass will be there waitin’ for ya.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jackson hears the click, and he can even smell the gunpowder for just a moment. Then, the moment is gone.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-443afbb9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 69
// module chunks = 0